module.exports = __webpack_public_path__ + "static/media/weddingsonline.bf09bbc0.png";